import React from "react";
import { Text, useMantineTheme } from "@mantine/core";

interface CaptionProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Caption - Small metadata text: timestamps, bylines, source labels.
 * Sits below body text hierarchy. Distinct role from body copy.
 * Usage: <Caption>March 2026 · 4 min read</Caption>
 */
export const Caption: React.FC<CaptionProps> = ({ children, className, style }) => {
  const theme = useMantineTheme();
  const other = theme.other as Record<string, string>;

  return (
    <Text
      className={className}
      style={{
        color: other.textDimmed,
        fontSize: "0.875rem",
        fontWeight: 400,
        lineHeight: 1.5,
        ...style,
      }}
    >
      {children}
    </Text>
  );
};

export default Caption;
